import type { FormikProps } from 'formik';
import { Text } from '@rsos/base-components';
import InputText from '@rsos/components/capstone/base/form/inputs/InputText';
import { Label } from '../../../../../AirAmbulanceForm/AirAmbulanceForm/AirAmbulanceFormStandalone.styles';
import type { TowProFormValues } from '../towProFormConstants';
import styles from './FormField.module.css';
import type { TowProStringField } from './fieldTypes';

export interface TextFieldProps {
  formik: FormikProps<TowProFormValues>;
  name: TowProStringField;
  label: string;
  placeholder?: string;
  onValueChange?: (value: string) => void;
  /** Normalizes the raw input before it is stored in the form. */
  transformValue?: (value: string) => string;
  /** Advisory message shown below the input; unlike an error it never blocks submission. */
  warning?: string;
}

function TextField({
  formik,
  name,
  label,
  placeholder,
  onValueChange,
  transformValue,
  warning,
}: TextFieldProps): JSX.Element {
  const error =
    formik.touched[name] && formik.errors[name]
      ? String(formik.errors[name])
      : undefined;

  return (
    <div className={styles.field}>
      <Label>
        <Text size="small" color="primaryText">
          {label}
        </Text>
      </Label>
      <InputText
        id={name}
        name={name}
        type="text"
        placeholder={placeholder}
        setFieldValue={formik.setFieldValue}
        value={formik.values[name]}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          if (transformValue) {
            const value = transformValue(e.target.value);
            formik.setFieldValue(name, value);
            onValueChange?.(value);
          } else {
            formik.handleChange(e);
            onValueChange?.(e.target.value);
          }
        }}
        onBlur={formik.handleBlur}
        error={error}
        style={{ fontSize: '14px' }}
      />
      {warning && !error && <div className={styles.warningText}>{warning}</div>}
    </div>
  );
}

export default TextField;
